import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import {
  NavMenuList,
  NavMenuItem,
} from "../StoryHeaderActions/StoryHeaderActions.styles";

/** Dropdown list wrapper — wider than the plain nav menus to fit name + email. */
export const CollaboratorsList = styled(NavMenuList)`
  min-width: 20rem;
  max-height: 20rem;
  overflow-y: auto;
  box-sizing: border-box;
`;

/** Same row chrome as `NavMenuItem`, but informational — not clickable. */
export const CollaboratorRow = styled(NavMenuItem)`
  cursor: default;
`;

export const Identity = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
`;

export const Name = styled.span`
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.highEmphasis};
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Email = styled.span`
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.mediumEmphasis};
  overflow: hidden;
  text-overflow: ellipsis;
`;

/** Right-hand column: role, with the lifecycle marker (e.g. "Pending") underneath. */
export const RoleGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 0 0 auto;
  margin-left: auto;
`;

export const RoleText = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const StatusText = styled.span`
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.lowEmphasis};
`;

export const EmptyText = styled.li`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.lowEmphasis};
  list-style: none;
  padding: ${spacing[2]} ${spacing[3]};
  white-space: normal;
`;

export const ErrorText = styled(EmptyText)`
  color: ${rawColors.accent.red500};
`;
